import { clientV3SDK, queryClient } from "@istari-frontend/api-client";
import { useMutation } from "@tanstack/react-query";

import { secureConnectionQueryKeys } from "./api/secure-connection-query-options";

export interface RevokeFileFromSendingConnectionArgs {
  connectionId: string;
  fileId: string;
  resourceId: string;
}

export function useRevokeFileFromSendingConnection() {
  return useMutation({
    mutationFn: ({ connectionId, fileId }: RevokeFileFromSendingConnectionArgs) =>
      clientV3SDK.revokeFileFromSendingRemote({ remoteId: connectionId, fileId }),
    onSuccess: (_data, { resourceId }) => {
      void queryClient.invalidateQueries({ queryKey: secureConnectionQueryKeys.sharesForResource(resourceId) });
      // Revoking removes a connection from the expected set; refresh per-connection sync status
      // so the rollup recomputes against the new shared-with set.
      void queryClient.invalidateQueries({
        queryKey: secureConnectionQueryKeys.resourceSyncStatusByConnection(resourceId),
      });
    },
  });
}
